import { Section, NextBar, In, Sel } from "./Fields";
import { PROPERTY_TYPES, BER_RATINGS, FURNISHED, HEATING, PARKING } from "./constants";

export default function PropertyStep({
  selectedLandlord, filteredProperties,
  propertyId, setPropertyId, propertyForm, setPropertyForm,
  onPrev, onNext,
}) {
  return (
    <Section title="Property details" subtitle={`For landlord: ${selectedLandlord?.name || "—"}`}>
      <div className="grid md:grid-cols-2 gap-3 mb-6">
        {filteredProperties.map((p) => (
          <button
            key={p.id}
            onClick={() => setPropertyId(p.id)}
            data-testid={`wizard-pick-property-${p.id}`}
            className={`text-left p-4 border rounded-md ${
              propertyId === p.id ? "border-[#1E3A5F] bg-[#1E3A5F] text-white" : "border-[#E5E7EB] bg-white hover:border-[#1E3A5F]/40"
            }`}
          >
            <div className="font-semibold">{p.address}</div>
            <div className={`text-xs mt-0.5 ${propertyId === p.id ? "text-white/70" : "text-[#6B7280]"}`}>
              {p.eircode || "—"} · {p.property_type} · {p.bedrooms}bd
            </div>
          </button>
        ))}
      </div>

      {!propertyId && (
        <div className="trent-card p-5 bg-[#FAFAF7]">
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#6B7280] mb-3">Add new property</div>
          <div className="grid md:grid-cols-3 gap-3">
            <In label="Address *" v={propertyForm.address} on={(v) => setPropertyForm({ ...propertyForm, address: v })} wide test="wizard-property-address" />
            <In label="Eircode" v={propertyForm.eircode} on={(v) => setPropertyForm({ ...propertyForm, eircode: v })} />
            <Sel label="Type" v={propertyForm.property_type} on={(v) => setPropertyForm({ ...propertyForm, property_type: v })} opts={PROPERTY_TYPES} />
            <Sel label="BER" v={propertyForm.ber_rating} on={(v) => setPropertyForm({ ...propertyForm, ber_rating: v })} opts={BER_RATINGS} />
            <Sel label="Furnished" v={propertyForm.furnished} on={(v) => setPropertyForm({ ...propertyForm, furnished: v })} opts={FURNISHED} />
            <In label="Bedrooms" v={propertyForm.bedrooms} on={(v) => setPropertyForm({ ...propertyForm, bedrooms: v })} type="number" />
            <In label="Bathrooms" v={propertyForm.bathrooms} on={(v) => setPropertyForm({ ...propertyForm, bathrooms: v })} type="number" />
            <Sel label="Heating" v={propertyForm.heating_type} on={(v) => setPropertyForm({ ...propertyForm, heating_type: v })} opts={HEATING} />
            <Sel label="Parking" v={propertyForm.parking} on={(v) => setPropertyForm({ ...propertyForm, parking: v })} opts={PARKING} />
          </div>
        </div>
      )}

      <NextBar onPrev={onPrev} onNext={onNext} testId="wizard-next-2" />
    </Section>
  );
}
